window.onload = function () {
    if (window.jQuery) {
        let $ = window.jQuery;
        $('.js-collapsible-trigger').click(function (event) {
            event.preventDefault();
            if ($('.js-collapsible-trigger').hasClass('is-open')) {
                $('.js-collapsible-trigger').not($(this)).removeClass('is-open');
                $('.js-collapsible-content').not($(this).next()).removeClass('is-open').css("height","0");

                dataLayer.push({ 'event': 'FAQS_question_expanded', 'Question': $(this).children('.faq__accordion-title').html() });
            }     
        });
    }
}
